"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, type ReactNode } from "react";
import { usePathname } from "next/navigation";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nProvider } from "@/app/providers/i18n-provider";
import { useAllCountriesQuery } from "@/entities/country/model/use-countries";
import { PostHogAnalyticsProvider } from "@/shared/analytics";
import { retryOn404, retryOn404Delay } from "@/shared/api/common";
import { AuthProvider, useAuth } from "@/shared/auth/use-auth";
function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: retryOn404,
        retryDelay: retryOn404Delay
      },
      mutations: {
        retry: 0
      }
    }
  });
}
function CountriesBootstrapper() {
  const $ = _c(2);
  const {
    isAuthenticated,
    isHydrated
  } = useAuth();
  const t0 = isHydrated && isAuthenticated;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      enabled: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useAllCountriesQuery(t1);
  return null;
}
function QueryScope(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [queryClient] = useState(createQueryClient);
  let t1;
  let t2;
  if ($[0] !== queryClient) {
    t1 = () => () => void queryClient.cancelQueries();
    t2 = [queryClient];
    $[0] = queryClient;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CountriesBootstrapper />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== queryClient) {
    t4 = <QueryClientProvider client={queryClient}>{t3}{children}</QueryClientProvider>;
    $[4] = children;
    $[5] = queryClient;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function SessionQueries(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  const {
    queryScope
  } = useAuth();
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname || $[1] !== queryScope) {
    t1 = pathname.startsWith("/auth/") ? "auth" : queryScope;
    $[0] = pathname;
    $[1] = queryScope;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const scope = t1;
  let t2;
  if ($[3] !== children || $[4] !== scope) {
    t2 = <QueryScope key={scope}>{children}</QueryScope>;
    $[3] = children;
    $[4] = scope;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export function AppProviders(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <PostHogAnalyticsProvider><I18nProvider><AuthProvider><SessionQueries>{children}</SessionQueries></AuthProvider></I18nProvider></PostHogAnalyticsProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}